import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import * as actions from '../actions/buildingpermit';

const initialState = {
  // building permit search
  buildingpermitCodeList: {},
  searchConfig: {
    data: [],
    state: null,
  },
  searchConfigResults: {
    data: [],
    state: null,
  },
  searchParams: {
    data: [],
    state: null,
  },
  searchParam: {
    data: {},
    state: null,
  },
  rematchLogs: {
    data: [],
    state: null,
  },
  searchResult: {
    data: [],
    options: {},
    state: null,
    pagination: {
      count: 0,
      page: 1,
      rowsPerPage: 50,
      rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
    },
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case actions.BUILDING_PERMIT_SEARCH_CONFIG_FETCH_START: {
      return state.setIn(['searchConfig', 'state'], fetchingState.FETCHING);
    }
    case actions.BUILDING_PERMIT_SEARCH_CONFIG_FETCH_SUCCESS: {
      return state
        .setIn(['searchConfig', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchConfig', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.BUILDING_PERMIT_SEARCH_CONFIG_FETCH_ERROR: {
      return state.setIn(['searchConfig', 'state'], fetchingState.ERROR);
    }

    case actions.SEARCH_CONFIG_RESULTS_FETCH_START: {
      return state.setIn(
        ['searchConfigResults', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.SEARCH_CONFIG_RESULTS_FETCH_SUCCESS: {
      return state
        .setIn(['searchConfigResults', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchConfigResults', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SEARCH_CONFIG_RESULTS_FETCH_ERROR: {
      return state.setIn(['searchConfigResults', 'state'], fetchingState.ERROR);
    }

    case actions.BUILDING_PERMIT_SEARCH_PARAMS_FETCH_START: {
      return state.setIn(['searchParams', 'state'], fetchingState.FETCHING);
    }
    case actions.BUILDING_PERMIT_SEARCH_PARAMS_FETCH_SUCCESS: {
      return state
        .setIn(['searchParams', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParams', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.BUILDING_PERMIT_SEARCH_PARAMS_FETCH_ERROR: {
      return state.setIn(['searchParams', 'state'], fetchingState.ERROR);
    }

    case actions.BUILDING_PERMIT_SEARCH_PARAM_INSERT_SUCCESS:
    case actions.BUILDING_PERMIT_SEARCH_PARAM_UPDATE_SUCCESS: {
      return state
        .setIn(['searchParam', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParam', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }

    case actions.BUILDING_PERMIT_SEARCH_PARAM_SET: {
      return state.setIn(
        ['searchParam', 'data'],
        fromJS(
          state
            .getIn(['searchParams', 'data'])
            .toJS()
            .find(v => v.searchParamID === action.searchParamID),
        ),
      );
    }

    case actions.BUILDING_PERMIT_SEARCH_PARAM_RESET: {
      return state.setIn(['searchParam', 'data'], fromJS({}));
    }

    case actions.BUILDING_PERMIT_CODES_FETCH_START: {
      return state.setIn(
        ['buildingpermitCodeList', action.codeType, action.name, 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.BUILDING_PERMIT_CODES_FETCH_SUCCESS: {
      return state
        .setIn(
          ['buildingpermitCodeList', action.codeType, action.name, 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['buildingpermitCodeList', action.codeType, action.name, 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.BUILDING_PERMIT_CODES_FETCH_ERROR: {
      return state.setIn(
        ['buildingpermitCodeList', action.codeType, action.name, 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.BUILDING_PERMIT_SEARCH_START: {
      return state
        .setIn(['searchResult', 'options'], fromJS(action.options))
        .setIn(['searchResult', 'state'], fetchingState.FETCHING)
        .setIn(['searchResult', 'pagination', 'page'], action.page)
        .setIn(['searchResult', 'pagination', 'rowsPerPage'], action.pageSize);
    }
    case actions.BUILDING_PERMIT_SEARCH_SUCCESS: {
      return state
        .setIn(['searchResult', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchResult', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['searchResult', 'pagination', 'count'],
          _.get(action, 'data.totalProperty.permitCount', 0),
        );
    }
    case actions.BUILDING_PERMIT_SEARCH_ERROR: {
      return state.setIn(['searchResult', 'state'], fetchingState.ERROR);
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(
        ['searchResult', 'pagination', 'page'],
        action.payload,
      );
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(
        ['searchResult', 'pagination', 'rowsPerPage'],
        action.payload,
      );
    }

    case actions.BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_START: {
      return state.setIn(['rematchLogs', 'state'], fetchingState.FETCHING);
    }
    case actions.BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_SUCCESS: {
      return state
        .setIn(['rematchLogs', 'state'], fetchingState.LOADED)
        .setIn(
          ['rematchLogs', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_ERROR: {
      return state.setIn(['rematchLogs', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};
